/* Rquiere de mixin.js */

var assistantAction = {
	data() {
		return {
			listAssistantActions: [],
			objectAssistantAction: {
				exist: 0,
				id: 0,
				option: null,
				message_begin: null,
				message_end: null,
				open_ai_type_interal_option: {},
				status: {},
				created_at: null,
				updated_at: null
			},
			searchingAssistantAction: false,
			savingAssistantAction: false,
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		getAssistantActionByAssistantId(assistantId) {
			this.searchingAssistantAction = true
			this.listAssistantActions = []
			let url = this.apiBackend + 'assistant/' + assistantId + '/actions'
			this.axiosActionIS(url, 'GET', 'getAssistantActionByAssistantIdResult')
		},
		getAssistantActionByAssistantIdResult(response) {
			this.searchingAssistantAction = false
			if (response.data.success == true) {
				this.listAssistantActions = response.data.data
			}
			this.getAssistantActionByAssistantIdResultLocal(response)
		},
		getAssistantActionByAssistantIdResultLocal(response) {
			console.log('getAssistantActionByAssistantIdResult no desarrollado', response)
		},
		saveAssistantAction() {
			this.savingAssistantAction = true
			let url = this.apiBackend + 'assistantAction/' + this.objectAssistant.id
			this.axiosActionIS(url, 'PUT', 'saveAssistantActionResult', this.objectAssistant)
		},
		saveAssistantActionResult(response) {
			this.savingAssistantAction = false
			if (response.data.success == true) {
				this.setObjectAssistantAction(response.data.data)
			}
			this.saveAssistantActionResultLocal(response)
		},
		saveAssistantActionResultLocal(response) {
			console.log('saveAssistantActionResultLocal no desarrollado', response)
		},
		setObjectAssistantAction(item) {
			for (const property in item) {
				this.objectAssistantAction[property] = item[property]
			}
		},
		showAssistantAction(id) {
			this.searchingAssistantAction = true
			let url = this.apiBackend + 'assistantAction/' + id
			this.axiosActionIS(url, 'GET', 'showAssistantActionResult')
		},
		showAssistantActionResult(response) {
			if (response.data.success == true) {
				this.setObjectAssistantAction(response.data.data)
			}
			this.showAssistantActionResultLocal(response)
		},
		showAssistantActionResultLocal(response) {
			console.log('showAssistantActionResultLocal no desarrollado', response)
		}

	},
};

export default assistantAction;